import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PerfilUsuarioService } from "./api-perfilUsuario.service";
import { PerfilUsuarioSignature } from "../../models/signature/perfilUsuarioSignature";
import { AtualizarSenhaPerfilUsuarioSignature } from "../../models/signature/AtualizarSenhaPerfilUsuarioSignature";

@Injectable({
  providedIn: 'root'
})

export class PerfilUsuarioDataService {

  constructor(private api: PerfilUsuarioService) {
  }

  public CarregaImagemPerfilUsuario(): Observable<any> {
    return this.api.CarregaImagemPerfilUsuario();
  }

  public CarregarDadosPerfilUsuario(): Observable<any> {
    return this.api.CarregarDadosPerfilUsuario();
  }

  public AtualizarDadosPerfilUsuario(signature: PerfilUsuarioSignature): Observable<any> {
    return this.api.AtualizarDadosPerfilUsuario(signature);
  }

  public ValidarSenhaAtualPerfilUsuario(signature: AtualizarSenhaPerfilUsuarioSignature): Observable<any> {
    return this.api.ValidarSenhaAtualPerfilUsuario(signature);
  }
}
